/**
 type EmitPostMessage = {
  isLnNotifacation: boolean;
  action: string;
  data: any;
};
 */

import { tryParse } from '@/utils';

export const notificationPostmessager = {
  // 提交给通知中心
  emit(emitData) {
    this.log('h5Sdk=>通知中心', emitData);
    const notificationIframe = this.getNotificationIframe();
    const emitPostMessage = this.emitData2EmitPostMessage(emitData);
    notificationIframe.contentWindow.postMessage(emitPostMessage, '*');
  },

  on(callback) {
    window.addEventListener(
      'message',
      messageEvent => {
        const { data } = messageEvent;
        if (!data || !data.isLnNotifacation) {
          // 过滤除了通知中心以外的消息
          return;
        }
        callback(data);
      },
      false
    );
  },
  emitData2EmitPostMessage(emitData) {
    return {
      ...emitData,
      isLnH5Sdk: true
    };
  },
  getNotificationIframe() {
    return document.querySelector('#ln-notification-frame');
  },
  log(...args) {
    console.log('\u001b[32m[通知中心]\u001b[0m', ...args);
  }
};
